<template>
  <Dialog>
    <Form
      id="upload-verification-file-form"
      submit-label="user.verificationFile.uploadDialog.submit"
      :is-loading="isLoading"
      :cancel-label="data?.cancelLabel"
      @submit="onSubmit"
      @cancel="dialogStore.closeDialog(DialogResponses.CANCEL)"
    >
      <template #errors>
        <div
          v-if="errors.length && errors.includes(ErrorIdent.UNKNOWN_ERROR)"
          class="mb-md"
        >
          <UnknownError />
        </div>
        <div
          v-if="
            errors.length &&
            errors.includes(ErrorIdent.VERIFICATION_UPLOAD_ERROR)
          "
          class="mb-md"
        >
          <ErrorFrame>
            {{ t('registration.error.verificationFile') }}
          </ErrorFrame>
        </div>
      </template>
      <template #default>
        <NotificationBar
          v-if="data?.showDrugHint"
          :type="NotificationType.WARN"
          description="checkout.DrugVerificationHint"
          class="!mt-0 mb-md"
          classes="!px-sm !gap-sm"
        />
        <InputFile
          id="verificationFiles"
          label="registration.verficationFileLabel"
          name="files"
          :required="false"
          @change="onChange"
        >
          <template #info
            ><div>
              {{ t('registration.verficationFile.info.text') }}
              <ul class="list-disc pl-md">
                <li>{{ t('registration.verficationFile.info.option1') }}</li>
                <li>{{ t('registration.verficationFile.info.option2') }}</li>
                <li>{{ t('registration.verficationFile.info.option3') }}</li>
                <li>{{ t('registration.verficationFile.info.option4') }}</li>
                <li>{{ t('registration.verficationFile.info.option5') }}</li>
                <li>{{ t('registration.verficationFile.info.option6') }}</li>
              </ul>
            </div>
          </template>
        </InputFile>
      </template>
    </Form>
  </Dialog>
</template>
<script setup lang="ts">
import Dialog from '@/components/dialog/components/dialogFrame/local/dialogFrame.vue';
import { DialogResponses, useDialogStore } from '@/stores/useDialogStore';
import { ErrorIdent } from '@/@types/errorIdents';
import Form from '@/components/formFields/localDialogForm/localDialogForm.vue';
import UnknownError from '~/components/formFields/errors/unknown/unknownError.vue';
import { useUploadVerificationFile } from './useUploadVerificationFile';
import ErrorFrame from '~/components/formFields/components/errorFrame/errorFrame.vue';
import { NotificationBar, NotificationType, InputFile } from '@/complib';
import useUploadVerificationFileDialog from '@/composables/dialogs/useUploadVerificationFileDialog';
const { t } = useTrans();
const { onSubmit, isLoading, errors } = useUploadVerificationFile();
const dialogStore = useDialogStore();
const data = useUploadVerificationFileDialog().getData();

function onChange() {
  errors.value = [];
}
</script>
